import { BaseFleetEntry } from "../../api/fleet"
import {
  isNotCoverDateMovedForward,
  isOnCoverDateWithinLast13Days,
  isOnCoverDateWithinLast13DaysError,
  isOnCoverWithinPolicyDates,
  isOnCoverWithinPolicyDatesError,
} from "./checks"
import { GeneratorProps } from "./types"

type OtherProps = {
  isRequired?: boolean
  isEdit?: boolean
}

export const isNotCoverDateMovedForwardEditError = `You can't move your on cover date forward after the time has already passed`

const validateOnCoverDate = (entry: Partial<BaseFleetEntry>, props: GeneratorProps, otherProps?: OtherProps) => {
  const { curentEntries, policyDuration, hasAdminAccess } = props
  if (otherProps?.isRequired && !entry.onCoverDate) {
    return `Please select an on cover date for this vehicle`
  }
  if (isOnCoverDateWithinLast13Days(entry, curentEntries, policyDuration, hasAdminAccess) === false) {
    return isOnCoverDateWithinLast13DaysError
  }
  if (isOnCoverWithinPolicyDates(entry, curentEntries, policyDuration, hasAdminAccess) === false) {
    return isOnCoverWithinPolicyDatesError
  }
  if (
    otherProps?.isEdit &&
    isNotCoverDateMovedForward(entry, curentEntries, policyDuration, hasAdminAccess) === false
  ) {
    return isNotCoverDateMovedForwardEditError
  }
  return undefined
}

export const generateValidateOnCoverDate =
  (props: GeneratorProps, otherProps?: OtherProps) => (entry: Partial<BaseFleetEntry>) =>
    validateOnCoverDate(entry, props, otherProps)
